import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(ElementUI, {locale})
Vue.use(ViewUI)
Vue.use(Antd)
Vue.config.productionTip = false
// 配置 LoadingBar 样式
ViewUI.LoadingBar.config({
    color: '#52c41a',         // 进度条颜色
    failedColor: '#f56c6c',   // 失败状态颜色
    height: 3,                // 进度条高度（px）
});
new Vue({
    router, store,

    render: h => h(App)
}).$mount('#app')
